<template>
  <ReportLayoutModerno
    id="conferenceList"
    :prefecture="prefecture"
    :period="convertDate(filter.startDate) + ' até ' + convertDate(filter.endDate)"
  >
    <template v-slot:icon>mdi-check-all</template>
    <template v-slot:title>RELATÓRIO DE CONFERÊNCIA</template>
    <template v-slot:sub-header>
      <h3 class="text-sm font-bold text-slate-600">
        Fornecedor: <span class="text-orange-600 uppercase">{{ provider && provider.provider_name ? provider.provider_name : '' }}</span>
      </h3>
    </template>

    <!-- LISTAGEM POR SECRETARIA -->
    <div v-for="(d, i) in data.secretariats" :key="i" class="mb-10 break-inside-avoid shadow-sm border border-slate-200 rounded-2xl overflow-hidden">
      <!-- CABEÇALHO DA SECRETARIA -->
      <div class="bg-slate-800 text-white px-8 py-4 flex items-center justify-between">
        <div class="flex flex-col">
          <span class="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em]">SECRETARIA</span>
          <span class="text-sm font-bold uppercase tracking-wide">{{ d.sec_name }}</span>
        </div>
        <v-icon color="white/20" size="32">mdi-office-building</v-icon>
      </div>

      <!-- TABELA DE VEÍCULOS -->
      <div class="overflow-x-auto">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-slate-50 border-b border-slate-200">
              <th class="p-4 text-[9px] font-black text-slate-500 uppercase tracking-wider">Subsetor</th>
              <th class="p-4 text-[9px] font-black text-slate-500 uppercase tracking-wider">Veículo</th>
              <th class="p-4 text-[9px] font-black text-slate-500 uppercase tracking-wider">Modelo</th>
              <th class="p-4 text-[9px] font-black text-slate-500 uppercase tracking-wider w-32">Placa</th>
              <th class="p-4 text-[9px] font-black text-slate-500 uppercase tracking-wider text-center">Abastecimentos</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(vehicle, ix) in d.vehicles" :key="ix" class="border-b border-slate-100 last:border-0 hover:bg-slate-50 transition-colors">
              <td class="p-4 text-xs font-medium text-slate-600 uppercase align-top">{{ vehicle.subsec_desc || '---' }}</td>
              <td class="p-4 text-xs font-bold text-slate-700 uppercase align-top">{{ vehicle.brand_desc }}</td>
              <td class="p-4 text-xs font-medium text-slate-600 uppercase align-top">{{ vehicle.model_desc }}</td>
              <td class="p-4 text-xs font-black text-orange-600 uppercase tracking-wider align-top">{{ vehicle.vehicle_board }}</td>
              <td class="p-2 align-top">
                <table class="w-full text-left border-collapse border border-slate-200">
                  <thead>
                    <tr class="bg-slate-100 border-b border-slate-200 text-[8px] font-black text-slate-500 uppercase">
                      <th class="p-2 border-r border-slate-200">Posto</th>
                      <th class="p-2 border-r border-slate-200">Combustível</th>
                      <th class="p-2 border-r border-slate-200">Data</th>
                      <th class="p-2 border-r border-slate-200 text-right">Litros Abastecidos</th>
                      <th class="p-2 border-r border-slate-200 text-right">Preço Licitado (aditivado)</th>
                      <th class="p-2 border-r border-slate-200 text-right">Valor Total Licitado</th>
                      <th class="p-2 border-r border-slate-200 text-center">Cupom</th>
                      <th class="p-2 text-center">Faturado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(supply, sx) in (vehicle.supplies || [])" :key="sx" class="border-b border-slate-100 hover:bg-white transition-colors text-[10px]">
                      <td class="p-2 border-r border-slate-200 font-medium uppercase">{{ supply.provider_name || '---' }}</td>
                      <td class="p-2 border-r border-slate-200 uppercase font-semibold text-slate-700">{{ supply.item_description_desc }}</td>
                      <td class="p-2 border-r border-slate-200 text-slate-500">{{ convertDateTime(supply.datehour) }}</td>
                      <td class="p-2 border-r border-slate-200 text-right font-bold text-slate-800">{{ supply.supply_liters_stocked ? realMaskII(Number(supply.supply_liters_stocked).toFixed(3)) : '0,000' }}</td>
                      <td class="p-2 border-r border-slate-200 text-right text-slate-600">{{ supply.supply_bidding_price ? realMaskII(Number(supply.supply_bidding_price).toFixed(3)) : '0,000' }}</td>
                      <td class="p-2 border-r border-slate-200 text-right font-bold text-slate-900">R$ {{ supply.supply_bidding_value ? realMask(Number(supply.supply_bidding_value).toFixed(2)) : '0,00' }}</td>
                      <td class="p-2 border-r border-slate-200 text-center text-slate-500 font-mono">{{ supply.supply_coupon }}</td>
                      <td class="p-2 text-center">
                        <span :class="supply.supply_billed ? 'text-blue-600 font-bold' : 'text-slate-400 font-bold'">
                          {{ supply.supply_billed ? 'SIM' : 'NÃO' }}
                        </span>
                      </td>
                    </tr>
                    <!-- VEHICLE TOTALS INSIDE NESTED TABLE -->
                    <tr class="bg-slate-50 font-bold text-[10px] text-slate-700">
                      <td class="p-2 border-r border-slate-200 uppercase" colspan="3">Totais</td>
                      <td class="p-2 border-r border-slate-200 text-right font-black text-orange-600">Lts: {{ vehicle.totalLiters ? realMaskII(Number(vehicle.totalLiters).toFixed(3)) : '0,000' }}</td>
                      <td class="p-2 border-r border-slate-200"></td>
                      <td class="p-2 border-r border-slate-200 text-right font-black text-orange-600">R$: {{ vehicle.totalValue ? realMask(Number(vehicle.totalValue).toFixed(2)) : '0,00' }}</td>
                      <td class="p-2 border-r border-slate-200"></td>
                      <td class="p-2"></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
          <!-- SUBTOTAL DA SECRETARIA -->
          <tfoot class="bg-slate-50/80 font-black text-slate-800 border-t border-slate-200">
            <tr>
              <td colspan="4" class="p-4 text-[10px] uppercase text-right text-slate-400 tracking-widest">SUBTOTAL {{ d.sec_name }}:</td>
              <td class="p-4 text-sm text-right text-slate-900 font-mono">
                <span class="text-orange-600">Lts: {{ d.totalLiters ? realMaskII(Number(d.totalLiters).toFixed(3)) : '0,000' }}</span> | 
                <span class="text-orange-600">Licitado: R$ {{ d.totalValue ? realMask(Number(d.totalValue).toFixed(2)) : '0,00' }}</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- RESUMOS FINAIS -->
    <div class="mt-16 break-inside-avoid p-8 bg-slate-900 rounded-3xl text-white shadow-2xl relative overflow-hidden">
      <v-icon style="color: rgba(255, 255, 255, 0.03) !important;" size="180" class="absolute right-0 bottom-0 pointer-events-none">mdi-finance</v-icon>
      
      <h2 class="text-xl font-black text-white uppercase tracking-[0.3em] text-center mb-10 pb-4 border-b border-white/10">RESUMO CONSOLIDADO POR COMBUSTÍVEL</h2>
      
    <div class="max-w-3xl mx-auto">
        <!-- RESUMO PREÇO LICITADO -->
        <div class="bg-white/5 rounded-2xl border border-white/10 overflow-hidden">
          <div class="px-4 py-3 text-center border-b border-white/10" style="background-color: rgba(79, 70, 229, 0.15);">
            <span class="text-[10px] font-black text-indigo-200 uppercase tracking-[0.2em]">RESUMO PREÇO LICITADO</span>
          </div>
          <table class="w-full text-[11px] text-left">
            <thead>
              <tr class="text-slate-400 uppercase font-black tracking-widest">
                <th class="p-4">Tipo</th>
                <th class="p-4 text-right">Preço</th>
                <th class="p-4 text-right">Total Lts</th>
                <th class="p-4 text-right">Total Valor</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(resume, idx) in data.finalTotals.totalTypes">
                <tr v-if="resume.name" :key="idx" class="border-t border-white/5">
                  <td class="p-4 font-bold uppercase">{{ resume.name }}</td>
                  <td class="p-4 text-right text-slate-300 font-mono">{{ resume.item_billing_price ? realMaskII(Number(resume.item_billing_price).toFixed(3)) : 0 }}</td>
                  <td class="p-4 text-right font-black">{{ resume.liters ? realMask(Number(resume.liters).toFixed(2)) : 0 }}</td>
                  <td class="p-4 text-right font-black text-orange-400 font-mono text-xs">R$ {{ resume.valueBilling ? realMask(Number(resume.valueBilling).toFixed(2)) : 0 }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <!-- TOTAIS GERAIS -->
      <div class="mt-10 pt-10 border-t border-white/10 grid grid-cols-1 md:grid-cols-2 gap-6">
         <!-- CARD VOLUME -->
         <div class="bg-white/5 p-6 rounded-2xl border border-white/10 flex flex-col items-center md:items-start">
            <span class="text-[9px] font-black text-slate-400 uppercase tracking-[0.3em] mb-2">VOLUME TOTAL ACUMULADO</span>
            <span class="text-3xl font-black text-white tracking-tighter">
              {{ data.finalTotals.totalFinalLiters ? realMask(Number(data.finalTotals.totalFinalLiters).toFixed(2)) : 0 }} 
              <span class="text-sm font-medium text-slate-500">LITROS</span>
            </span>
         </div>
         
         <!-- CARD VALOR -->
         <div class="bg-white/5 p-6 rounded-2xl border border-white/10 flex flex-col items-center md:items-end">
             <span class="text-[9px] font-black text-orange-500 uppercase tracking-[0.3em] mb-2">VALOR TOTAL DO PERÍODO</span>
             <span class="text-3xl font-black text-white font-mono tracking-tighter uppercase">
               <span class="text-lg text-slate-500 font-medium mr-2">R$</span>
               {{ data.finalTotals.totalFinalValuesBilling ? realMask(Number(data.finalTotals.totalFinalValuesBilling).toFixed(2)) : '0,00' }}
             </span>
         </div>
      </div>
    </div>
  </ReportLayoutModerno>
</template>

<script>
import helpers from "../../../mixins/helpers";
import ReportLayoutModerno from "@/components/ReportLayoutModerno.vue";

export default {
  components: { ReportLayoutModerno },
  props: ["data", "filter", "prefecture", "provider"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style></style>